import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FormsDashboardLayer from "../components/dashboards/FormsDashboardLayer";

const FormsDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Forms Dashboard">
        <FormsDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default FormsDashboardPage;
